import { AuthorizationFacade } from "./authorization.facade";

export function initIdentityFactory(
  authorizationFacade: AuthorizationFacade,
) {
  return () => authorizationFacade.loadDefaultContext();
}

